import React from 'react'
import Fade from 'react-reveal/Fade'
import IcAlam from 'assets/images/icons/ic-alam.png'
import IcFleksibel from 'assets/images/icons/ic-fleksibel.png'
import IcModern from 'assets/images/icons/ic-modern.png'
import IcPelayanan from 'assets/images/icons/ic-pelayanan.png'
import IcFasilitas from 'assets/images/icons/ic-fasilitas.png'
import IcKualitas from 'assets/images/icons/ic-kualitas.png'
import IcLingkungan from 'assets/images/icons/ic-lingkungan.png'

export default function About() {
    return (
        <section
            className="container mt-3"
            style={{
                color: "#696969",
                marginTop: "-60px",
            }}
        >
            <div className="row text-center justify-content-center">
                <div className="my-5">
                    <h1 style={{ color: "#333333", fontWeight: "700" }}>
                        Destinasi Terbaik untuk Liburan dan Acara Spesial
                    </h1>
                    <p
                        className="lead mt-4 px-3"
                        style={{
                            fontSize: "1.1rem",
                            color: "#555",
                            maxWidth: 800,
                            margin: "0 auto",
                        }}
                    >
                        Nikmati pengalaman unik di Cipanas, Puncak Bogor, bersama Green Hill Resort - Kemuning Group. 
                        Kami menyediakan akomodasi villa yang tenang dan venue event yang menawan, menciptakan momen indah yang akan selalu Anda kenang.
                    </p>
                </div>
            </div>

            {/* Bagian Keunggulan */}
            <div className="row mt-1 text-center justify-content-center">
                <Fade up>
                    {[
                        {
                            img: IcAlam,
                            title: "Keindahan Alam",
                            text: "Green Hill Resort menyatu dengan alam Cipanas, menawarkan pengalaman nyaman dan menenangkan.",
                        },
                        {
                            img: IcFleksibel,
                            title: "Fleksibilitas Acara",
                            text: "Nikmati venue serbaguna untuk berbagai acara, dari pertemuan intim hingga perayaan besar.",
                        },
                        {
                            img: IcModern,
                            title: "Kemudahan Modern",
                            text: "Nikmati kemudahan pemesanan dan pengaturan acara dengan layanan berbasis teknologi.",
                        },
                    ].map((item, index) => (
                        <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
                            <div
                                className="card h-100"
                                style={{
                                    border: "none",
                                    borderRadius: "15px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                }}
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    style={{
                                        display: "block",
                                        margin: "20px auto 10px",
                                        width: "70px",
                                    }}
                                />
                                <div className="card-body">
                                    <h5 style={{ color: "#333333", fontWeight: "600" }}>{item.title}</h5>
                                    <p
                                        className="lead"
                                        style={{
                                            fontSize: "0.9rem",
                                            color: "#666",
                                        }}
                                    >
                                        {item.text}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </Fade>
            </div>

            {/* Bagian Komitmen */}
            <div className="row text-center justify-content-center my-5">
                <Fade up>
                    <h3
                        className="mt-3 mb-4"
                        style={{ color: "#333333", fontWeight: "700" }}
                    >
                        Komitmen Kami
                    </h3>
                    <div className="row justify-content-center">
                        {[
                            {
                                img: IcPelayanan,
                                title: "Pelayanan",
                                text: "Pelayanan cepat, ramah, dan responsif untuk kenyamanan Anda.",
                            },
                            {
                                img: IcFasilitas,
                                title: "Fasilitas Berkualitas",
                                text: "Fasilitas modern untuk kebutuhan dan kenyamanan acara Anda.",
                            },
                            {
                                img: IcLingkungan,
                                title: "Lingkungan",
                                text: "Suasana alami dan pemandangan indah yang menenangkan.",
                            },
                            {
                                img: IcKualitas,
                                title: "Kualitas Terjaga",
                                text: "Kualitas tinggi untuk memenuhi harapan Anda di Green Hill Resort.",
                            },
                        ].map((item, index) => (
                            <div className="col-12 col-sm-6 col-md-3 mb-4" key={index}>
                                <div
                                    className="card h-100"
                                    style={{
                                        border: "none",
                                        borderRadius: "15px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                    }}
                                >
                                    <img
                                        src={item.img}
                                        alt={item.title}
                                        style={{
                                            display: "block",
                                            margin: "20px auto 10px",
                                            width: "70px",
                                        }}
                                    />
                                    <div className="card-body">
                                        <h5 style={{ color: "#333333", fontWeight: "600" }}>{item.title}</h5>
                                        <p
                                            className="lead"
                                            style={{
                                                fontSize: "0.9rem",
                                                color: "#666",
                                            }}
                                        >
                                            {item.text}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Fade>
            </div>
        </section>
    )
}
